/* eslint-disable array-callback-return */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { withRouter } from 'react-router';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import { tableHead } from './tableHead';
import { GridWidth } from '../../../../../SharedModules/StyleConstant/StyleConstant';
import {
  dispatchSetMDspectheraCodeDetails,
  dispatchSetSpecInSys,
  getMDspectheraCodeDetails,
} from '../../store/actions';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import TextBoxRender from '../textBoxRender';

function MDspecteracode(props) {
  const {
    setUpdateMDSpecThera,
    fullScreenView,
    setSuccessMessage,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    setFullScreenView,
    isReadOnly,
    isEnabledByRole,
  } = props;
  const dispatch = useDispatch();

  const searchMDSpectheraDetail = (value) =>
    dispatch(getMDspectheraCodeDetails(value));

  const mdspecthera = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.mdspecthera
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const gridStyle = useMemo(() => ({ height: '500px', width: GridWidth }), []);
  const [specTheraData, setSpecTheraData] = useState([]);

  useEffect(() => {
    if (!(mdspecthera?.length > 0)) {
      searchMDSpectheraDetail();
    }
    setFullScreenView(false);
  }, []);

  useEffect(() => {
    if (disabledSaveCancelBtn) {
      searchMDSpectheraDetail();
    }
  }, [disabledSaveCancelBtn]);

  useEffect(() => {
    if (mdspecthera) {
      const tableDataUpdate = [];
      mdspecthera.map((item) => {
        const data = {
          updateRecord: item.updateRecord ? item.updateRecord : false,
          oldSpecTheraClassCd: item.specTheraClassCd,
          oldStartQtr: item.startQtr,

          specTheraClassCd: item.specTheraClassCd,
          startQtr: item.startQtr,
          endQtr: item.endQtr,
        };
        tableDataUpdate.push(data);
      });
      setSpecTheraData(tableDataUpdate);
      setUpdateMDSpecThera(tableDataUpdate);
    }
  }, [mdspecthera]);
  const onEditingStopped = (e) => {
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    const updatedMDSpecThera = specTheraData;
    updatedMDSpecThera.map((item, index) => {
      if (index === e.rowIndex) {
        item.updateRecord = true;
        item.oldSpecTheraClassCd = item.oldSpecTheraClassCd;
        item.oldStartQtr = item.oldStartQtr;
        item.startQtr =
          e.column.colId === 'startQtr' ? e.newValue : item.startQtr;
        item.endQtr = e.column.colId === 'endQtr' ? e.newValue : item.endQtr;
        item.specTheraClassCd =
          e.column.colId === 'specTheraClassCd'
            ? e.newValue
            : item.specTheraClassCd;
        item.lastUpdateUserId = logInUser || 'DRAMS';
      }
    });
    setUpdateMDSpecThera(updatedMDSpecThera);
  };
  const frameworkComponents = {
    TextBoxRender: (cellInfo) => (
      <TextBoxRender
        cellInfo={cellInfo}
        disabled={isReadOnly || !isEnabledByRole}
        addSpecthera
        addAction={addRow}
      />
    ),
  };

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const specinsys = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.specinsys
  );
  const addRow = (e, data) => {
    setDisabledSaveCancelBtn(false);
    const newRow = [
      {
        specTheraClassCd: '',
        startQtr: '',
        endQtr: '',

        oldSpecTheraClassCd: null,
        oldStartQtr: null,
        lastUpdateUserId: logInUser || 'DRAMS',
        newRecord: true,
        updateRecord: false,
      },
    ];
    let loopdata = data ? data : specTheraData;
    const dataWithNewRow = loopdata?.map((x) => {
      return x;
    });
    dataWithNewRow.unshift(newRow[0]);
    setSpecTheraData(dataWithNewRow);
    setUpdateMDSpecThera(dataWithNewRow);
    if (data) {
      dispatch(dispatchSetMDspectheraCodeDetails(dataWithNewRow));
      dispatch(dispatchSetSpecInSys(!specinsys));
    }
  };

  const gridHeight = fullScreenView ? '60vh' : 360;
  return (
    <>
      <div style={gridStyle} className="ag-theme-alpine">
        <Grid
          gridHeight={gridHeight}
          rowData={specTheraData}
          columnDefs={tableHead}
          data-testid="onEditingStopped"
          enterMovesDown
          frameworkComponents={frameworkComponents}
          suppressCellFocus
          onCellFocused={onCellFocused}
          handleFullScreenViewClick={handleFullScreenViewClick}
          fullScreenView={fullScreenView}
          singleClickEdit
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          onCellValueChanged={onEditingStopped}
          exportFile
          fileName="MD Spec Thera Code"
          addTxt="Add Spec Thera Code"
          addAction={addRow}
          disableAddAction={isReadOnly || !isEnabledByRole}
        />
      </div>
    </>
  );
}
export default withRouter(MDspecteracode);
